<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/logoholcim.jpg')"
          class="my-2"
          contain
          height="90"
        />
      </v-col>

      <v-row>
        <v-col cols="12" md="12"  >
          <v-card elevation="10">
           
            <v-img
              class="ma-2"
              :src = "srcfoto"
              contain
              max-width ="600"
              
            ></v-img>
              
          </v-card>
        </v-col>
      </v-row>


      <v-col class="ma-1">
        <h4 class="headline font-weight-bold mb-3">
          ANÁLISIS DE RIESGOS {{ iddocum }}
        </h4>

      </v-col>

      <v-col
        class="mb-1"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Identificación
        </h2>

        <v-row justify="center">
         
          <v-col cols="11">
            <v-text-field
              outlined
              readonly
              dense
              label="Número de Nómina"
              placeholder="Número de Nómina"
              hide-details
              v-model="clave"
            ></v-text-field>
          </v-col>

          <v-col cols="11">
            <v-text-field
              outlined
              label="Nombre"
              hide-details
              readonly
              dense
              v-model="nombre"
            ></v-text-field>
          </v-col>

          <v-col cols="11">
            <v-text-field
              outlined
              hide-details
              dense
              readonly
              label="Planta"
              v-model="nomplanta"
            ></v-text-field>
          </v-col>
      
          <v-col cols="11">
            <v-text-field
              outlined
              hide-details
              dense
              label="Area"
              v-model="nomarea"
            ></v-text-field>
          </v-col>

          <v-col cols="11">
            <v-textarea
             outlined
             auto-grow
             rows="1"
             prepend-icon="mdi-comment"
             label="Tarea"
             v-model="tarea"
             hide-details
             two-rows>
            </v-textarea>
          </v-col>
          
           <v-col
              cols="11"
            >
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                readonly
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Fecha"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  @input="menu2 = false"
                  readonly
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="11">

               
                <v-btn class="mb-2" block large @click="saveinfo" color="info">Grabar</v-btn>
             
           
             <v-toolbar dense dark color="green lighten-1">
               Comunicación
             </v-toolbar>

            <v-radio-group
              multiple
              v-model="comunicacion"
            >
              
              <v-switch
              v-model="pa1"
              label="¿Informé a las personas y área involucrada?"
              color="blue"
              hide-details
              readonly
              ></v-switch>

              <v-switch
              v-model="pa2"
              label="¿Mi supervisor en turno está enterado de lo que hará y como lo hará?"
              color="blue"
              readonly
              hide-details
              ></v-switch>

              <v-switch
              v-model="pa3"
              label="¿Se requiere solicitar autorización de ingreso al área?"
              color="blue"
              readonly
              hide-details
              ></v-switch>

              <v-switch
              v-model="pa4"
              label="¿La instrucción de la actividad se recibió claramente ?"
              color="blue"
              readonly
              hide-details
              ></v-switch>

              <v-switch
                v-model="pa5"
                label="¿Entiendo lo que voy a hacer y no tengo dudas acerca de cómo realizar la actividad?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

            </v-radio-group>
          </v-col>


          <v-col cols="11">
             <v-toolbar  dark color="green lighten-1">
               Equipo de Protección Personal adecuado
             </v-toolbar>
          
             <v-switch
               v-model="pb6"
               label="¿El EPP que utilizare es el adecuado y suficiente para el trabajo?"
               color="blue"
               readonly
               hide-details
             ></v-switch>

             <v-switch
               v-model="pb7"
               label="¿Revisé el EPP y se encuentra en buenas condiciones?"
               color="blue"
               readonly
               hide-details
             ></v-switch>

             <v-switch
               v-model="pb8"
               label="¿Requiero EEP adicional o especial?"
               color="blue"
               readonly
               hide-details
             ></v-switch>
          </v-col>


          <v-col cols="11">

            <v-toolbar  dark color="green lighten-1">
              Exposición a los peligros y/o energías
            </v-toolbar>

              <v-btn color="red" dark>Requiero apoyo</v-btn>
               
             <v-switch
               v-model="pc9"
               label="¿Pueden mis manos o alguna parte de mi cuerpo golpear contra objetos?"
               color="blue"
               readonly
               hide-details
             ></v-switch>

              <v-switch
                v-model="pc10"
                label="¿Puede ser golpeado por objetos o vehículos?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

              <v-switch
                v-model="pc11"
                label="¿Puedo quedar atrapado sobre, entre o dentro de equipos?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

              <v-switch
                v-model="pc12"
                label="¿Puedo sufrir caídas a desnivel o al mismo nivel?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

              <v-switch
                v-model="pc13"
                label="¿Puedo entrar en contacto con temperaturas extremas?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

              <v-switch
                v-model="pc14"
                label="¿Puedo entrar en contacto con corriente eléctrica?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

              <v-switch
                v-model="pc15"
                label="¿Puedo inhalar o entrar en contacto con una sustancia peligrosa?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

              <v-switch
                v-model="pc16"
                label="¿Existe energía gravitacional o potencial que se pueda liberar?"
                color="blue"
                readonly
                hide-details
              ></v-switch>
             
              <v-switch
                v-model="pc17"
                label="¿Existen obstáculos que puedan generar tropezones o resbalones?"
                color="blue"
                readonly
                hide-details
              ></v-switch>

              <v-switch
                v-model="pc18"
                label="¿Puede haber un arranque repentino de equipos?"
                color="blue"
                readonly
                hide-details
              ></v-switch>
          </v-col>

          <v-col cols="11">
           
            <v-toolbar  dark color="green lighten-1">
              Herramientas y equipo
            </v-toolbar>
          
            <v-switch
              v-model="pd19"
              label="¿He revisado la herramienta y se encuentra en buenas condiciones?"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-switch
              v-model="pd20"
              label="¿La herramienta es la adecuada para el trabajo?"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-switch
              v-model="pd21"
              label="¿ Requiero herramienta adicional ?"
              color="blue"
              readonly
              hide-details
            ></v-switch>
          </v-col>

          <v-col cols="11">
           
            <v-toolbar   dark color="green lighten-1">
              Orden y limpieza, procedimientos e instructivos
            </v-toolbar>

            <v-switch
              v-model="pe22"
              label="¿ Existe algún instructivo, AST, o procedimiento que aplique y deba consultar ?"
              color="blue"
              readonly
              hide-details
            ></v-switch>
            
            <v-switch
              v-model="pe23"
              label="¿ Existe el orden, limpieza y espacios suficientes para realizar la actividad ?"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-switch
              v-model="pe24"
              label="¿ Está relacionado con un FPE o requiero un permiso ?"
              color="blue"
              readonly
              hide-details
            ></v-switch>
          </v-col>

          <v-col cols="11">
           
            <v-toolbar   dark color="green lighten-1">
              Condiciones Físicas Mentales
            </v-toolbar>

            <v-switch
              v-model="pf25"
              label="¿ Me siento apto y estoy capacitado ?"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-switch
              v-model="pf26"
              label="¿ Mi condición física me lo permite ?"
              color="blue"
              readonly
              hide-details
            ></v-switch>
          </v-col>

          <v-col cols="11">
            <v-alert
              color="red"
              dark
              border="top"
              dense
              type="error"
            >
              ¿ Mi estado mental me permite hacer la tarea?.
            
            </v-alert>

            <v-switch
              v-model="pg27"
              label="Prisa"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-switch
              v-model="pg28"
              label="Fatiga"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-switch
              v-model="pg29"
              label="Exceso de Confianza"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-switch
              v-model="pg30"
              label="Problemas que me molesten o distraen"
              color="blue"
              readonly
              hide-details
            ></v-switch>

            <v-alert class="ma-1 pa-1"
              color="orange"
              dark
              border="top"
              dense
              type="info"
            >
               EVITAR ERRORES.
              <v-card-text justify="left">
                <div>1. Ojos No en la tarea </div>
                <div>2. Mente No en la tarea</div>
                <div>3 Pérdida de equilibrio, tracción o agarre</div>
                <div>4. Entrar en línea de fuego </div>
                  
              </v-card-text>
            
            </v-alert>

        </v-col>

        <v-alert
          dark
          border="left"
          dense
          type="success"
        >
          NOTA: Si sus estados mentales lo distraen de la tarea, tomes el tiempo para corregirlos y/o hable con su supervisor. Eleve su nivel de alerta.
         
        </v-alert>

          <v-row>
            <v-col>
              <v-card class="ma-3 pa-2">
                Este análisis no sustituye al AST-EROB ARO IPER
                <h3>Elabórelos en caso de actividades laborales peligrosas</h3>

<!--                 <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn large @click="saveinfo" color="info">Grabar</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
 -->
              </v-card>
            </v-col>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'analisis',

  data: () => ({

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,

    nomarea: '',
    nomplanta: '',
    iddocum : '',
    srcfoto: '',

    //PREGUNTAS
    pa1: 0,
    pa2: 0,
    pa3: 1,
    pa4: 0,
    pa5: 1,

    pb6: 0,
    pb7: 0,
    pb8: 0,

    pc9: 0,
    pc10: 0,
    pc11: 0,
    pc12: 0,
    pc13: 0,
    pc14: 0,
    pc15: 0,
    pc16: 0,
    pc17: 0,
    pc18: 0,

    pd19: 0,
    pd20: 0,
    pd21: 0,

    pe22: 0,
    pe23: 0,
    pe24: 0,

    pf25: 0,
    pf26: 0,

    pg27: 0,
    pg28: 0,
    pg29: 0,
    pg30: 0,

    nombre: '',
    clave: '',
    tarea: '',

    comunicacion:[],
    equipo:[],
    energia:[],
    hta:[],
    orden:[],
    condicion:[],
    mental :[],
  }),

  created(){

    console.log('router AR', this.$route.params)
    // this.idcita = this.$route.params.idcita
    let rutaAr = this.$route.params.docum.iddocum.toString()
    this.iddocum = rutaAr

    //LLAMAR A LA API PARA GRABAR DATOS
    this.$http.get('v2/getar/' + rutaAr).then( response => {
      console.log(response.data)

      this.docum = response.data.result.Condocum
      this.Registros = response.data.result.Registros

      // this.iddocum = this.docum.iddocumtoString()


      var urlop = this.$http.options.root.replace ("api", "imagen")
      console.log(urlop)
      let uriFotos =  this.iddocum + 'fotoa.png'
      this.srcfoto = urlop + uriFotos


      this.hora = this.docum.hora
      this.clave = this.docum.nomina
      this.nombre = this.docum.nomuser

      this.nomplanta = this.docum.nomplanta
      this.nomarea = this.docum.nomarea
      this.tarea = this.docum.tarea
      this.date = this.docum.fecha



      this.pa1 = parseInt(this.Registros.pa1)
      this.pa2 = parseInt(this.Registros.pa2)

      this.pa3 = parseInt(this.Registros.pa3)
      this.pa4 = parseInt(this.Registros.pa4)
      this.pa5 = parseInt(this.Registros.pa5)

      this.pb6 = parseInt(this.Registros.pb6)
      this.pb7 = parseInt(this.Registros.pb7)
      this.pb8 = parseInt(this.Registros.pb8)
        
      this.pc9 = parseInt(this.Registros.pc9)
      this.pc10 = parseInt(this.Registros.pc10)
      this.pc11 = parseInt(this.Registros.pc11)
      this.pc12 = parseInt(this.Registros.pc12)
      this.pc13 = parseInt(this.Registros.pc13)
      this.pc14 = parseInt(this.Registros.pc14)
      this.pc15 = parseInt(this.Registros.pc15)
      this.pc16 = parseInt(this.Registros.pc16)
      this.pc17 = parseInt(this.Registros.pc17)
      this.pc18 = parseInt(this.Registros.pc18)

      this.pd19 = parseInt(this.Registros.pd19)
      this.pd20 = parseInt(this.Registros.pd20)
      this.pd21 = parseInt(this.Registros.pd21)

      this.pe22 = parseInt(this.Registros.pe22)
      this.pe23 = parseInt(this.Registros.pe23)
      this.pe24 = parseInt(this.Registros.pe24)

      this.pf25 = parseInt(this.Registros.pf25)
      this.pf26 = parseInt(this.Registros.pf26)

      this.pg27 = parseInt(this.Registros.pg27)
      this.pg28 = parseInt(this.Registros.pg28)
      this.pg29 = parseInt(this.Registros.pg29)
      this.pg30 = parseInt(this.Registros.pg30)

    }).catch(error => {
      console.log(error)
    }).finally(()  => this.loading = false)

  },


  methods: {
    saveinfo(){
      let payload = {
        Docum : {
          fecha: this.date,
          hora: '10:20',
          idusuarioweb: 25,
          idplanta: 1,
          idarea: 1,
          nomuser: 'Juan Perez',
          nomina: '123',
          tarea: 'Instalar el clima',
        },

        Registros: {
          pa1:  String(this.pa1),
          pa2:  String(this.pa2),
          pa3:  String(this.pa3),
          pa4:  String(this.pa4),
          pa5:  String(this.pa5),

          pb6:  String(this.pb6),
          pb7:  String(this.pb7),
          pb8:  String(this.pb8),

          pc9:  String(this.pc9),
          pc10: String(this.pc10),
          pc11: String(this.pc11),
          pc12: String(this.pc12),
          pc13: String(this.pc13),
          pc14: String(this.pc14),
          pc15: String(this.pc15),
          pc16: String(this.pc16),
          pc17: String(this.pc17),
          pc18: String(this.pc18),

          pd19: String(this.pd19),
          pd20: String(this.pd20),
          pd21: String(this.pd21),

          pe22: String(this.pe22),
          pe23: String(this.pe23),
          pe24: String(this.pe24),

          pf25: String(this.pf25),
          pf26: String(this.pf26),

          pg27: String(this.pg27),
          pg28: String(this.pg28),
          pg29: String(this.pg29),
          pg30: String(this.pg30)
        }

      }
      console.log('payload',payload)

      //LLAMAR A LA API PARA GRABAR DATOS
      this.$http.post('v2/ar.insert',payload).then( response => {
        console.log(response.data)

      }).catch(error => {
        console.log(error)
      }).finally(()  => this.loading = false)
    }
  }
}
</script>
